// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"55cd576f","239":"626f97dd","732":"a7fcaa43"}[chunkId] + ".chunk.js";
};